import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import HeaderButtons from "@/components/Header/InterventionTemplate";
import { TAB_KEYS } from "@/constants/TabKeys";
import {
  INTERVENTION_TEMPLATE_INCLUDES,
  useGetInterventionTemplate,
} from "@/entities/intervention-template";
import TemplateEditor from "@/features/InterventionTemplates/Details/TemplateEditor";
import { InterventionTemplateJsonEditor } from "@/modules/intervention-template/intervention-template-json-editor";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";
import { ContextTabs } from "@/ui/context-tabs";

const { Content } = Layout;

const Details = () => {
  const { t } = useTranslation();
  const id = useIdParam();

  const includes = [
    INTERVENTION_TEMPLATE_INCLUDES.REVISION,
    INTERVENTION_TEMPLATE_INCLUDES.REFERENCE_REVISION,
  ].join(",");

  const { template, isLoading, error } = useGetInterventionTemplate(id, {
    params: {
      include: includes,
    },
  });

  const tabs = [
    {
      key: TAB_KEYS.TEMPLATE_EDITOR,
      label: t("form:templateEditor"),
      children: <TemplateEditor template={template} loading={isLoading} />,
    },
    {
      key: TAB_KEYS.TEMPLATE_JSON,
      label: t("form:jsonEditor"),
      children: <InterventionTemplateJsonEditor template={template} />,
    },
  ];

  return (
    <PageItemGate model="interventiontemplate" queryError={error}>
      <BaseHeader
        title={template?.name}
        loading={isLoading}
        extra={
          !isLoading && [
            <HeaderButtons key="HeaderButtons" template={template} />,
          ]
        }
      />
      <Content>
        <ContextTabs defaultActiveKey={TAB_KEYS.TEMPLATE_EDITOR} items={tabs} />
      </Content>
    </PageItemGate>
  );
};

export default Details;
